import { gettext } from '@eventbrite/i18n';
import { format, isBefore, isValid, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { isEmpty } from 'lodash';
import {
    AccordionSection,
    CalendarType,
} from '../../state/infiniteCalendarSeries';
import { longDateFormat } from '../TimedEntrySeries/types';

export const DATE = gettext('Date').toString();
export const TIME = gettext('Time').toString();
export const TICKETS = gettext('Tickets').toString();
export const DATE_AND_TIME = gettext('Date and time').toString();
export const CHOOSE_OPTIONS = gettext('Choose options').toString();

export const getLocalFormattedDateOrEmpty = (date: string, locale: string) => {
    const parsedDate = new Date(date);
    if (!isValid(parsedDate)) {
        return '';
    }
    return parsedDate.toLocaleDateString(locale, longDateFormat);
};

export const getMonthAndYearFromDate = (utcDate: string) => {
    const date = new Date(utcDate);
    return { month: date.getMonth(), year: date.getFullYear() };
};

export const getCurrentOrFutureMonth = (utcDate: string) => {
    const inputDate = new Date(utcDate);
    const today = new Date();
    const referenceDate = isBefore(inputDate, today) ? today : inputDate;
    return {
        month: referenceDate.getMonth(),
        year: referenceDate.getFullYear(),
    };
};

export const isAccordionSectionOpen = (
    activeSection: AccordionSection | null,
    currentSection: AccordionSection,
): boolean => {
    return activeSection === currentSection;
};

export const getDateSectionTitle = (calendarType: CalendarType) =>
    calendarType === CalendarType.compactWithSession ? DATE_AND_TIME : DATE;

export const getDisplayDate = ({
    activeSection,
    calendarType,
    date,
    locale,
    isEventOnline,
    timezone,
}: {
    activeSection?: AccordionSection | null;
    calendarType?: CalendarType | null;
    date: string;
    locale: string;
    isEventOnline?: boolean;
    timezone: string;
}): string => {
    if (activeSection === AccordionSection.date || isEmpty(date)) {
        return '';
    }

    const hourFormat = 'hh:mm aa';
    const weekDayMonthDate = getLocalFormattedDateOrEmpty(date, locale);

    const time = isEventOnline
        ? format(new Date(date), hourFormat)
        : formatInTimeZone(parseISO(date), timezone, hourFormat);

    switch (calendarType) {
        case CalendarType.compactWithSession:
            return `${weekDayMonthDate}・${time}`;
        default:
            return weekDayMonthDate;
    }
};
